import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import CRSListingPage from '../pages/crs/crsListingPage';
import CrsRiskIndicator from '../pages/crs/crsRiskIndicator';
import CRSDetailPage from '../pages/crs/crsRiskDetail';
import Settings from '../pages/settings';
import { crsHasPermission } from '../util';
import {
  CRS_TAB_LIST,
  CRS_TAB_PAGEID_LIST
} from '../pages/constants/crsContants';
import MatchingConfiguration from '../pages/ns/matchingConfig'; //? Move to nsRoute file after configure API
import CreateEditMatchingConfiguration from '../pages/ns/matchingConfig/CreateEditMatchingConfiguration';
import { getSelectedResources } from '../util/resourceManager';
import NotFoundPage from '../pages/common/NotFoundPage';

const { crsResources } = getSelectedResources();

const CRSSettings = () => (
  <Settings
    title="Global Setting for Customer Risk Score"
    crsTabList={CRS_TAB_LIST}
    crstabPageIdList={CRS_TAB_PAGEID_LIST}
    GlobalSettingPageType={'CRS'}
  />
);

export default (authentication) => {
  //protect route by user role
  const RestrictedRender = (Component) => {
    return crsHasPermission(authentication) ? <Component /> : <NotFoundPage />;
  };

  let alertsListingPermitted = false;
  let investigationPagePermitted = false;
  let globalSettingsPermitted = false;
  let riskIndicatorConfigurationPermitted = false;
  let homeUrl = null;

  if (
    authentication &&
    Array.isArray(authentication.data) &&
    authentication.data.length > 0
  ) {
    // list of Attributes
    const listOfAttributes = authentication.data;
    listOfAttributes.map((attribute) => {
      const scopes = attribute.details?.resource?.operations
        ? attribute.details.resource.operations
        : null;

      if (scopes) {
        if (scopes.includes(crsResources.APP_3_RESOURCE_UI_CRS_CUSTOMER_LIST)) {
          alertsListingPermitted = true;
        }

        if (
          scopes.includes(crsResources.APP_3_RESOURCE_UI_CRS_CUSTOMER_DETAIL)
        ) {
          investigationPagePermitted = true;
        }

        if (
          scopes.includes(crsResources.APP_3_RESOURCE_UI_CRS_GLOBAL_SETTINGS)
        ) {
          globalSettingsPermitted = true;
        }

        if (
          scopes.includes(
            crsResources.APP_3_RESOURCE_UI_CRS_RISK_INDICATOR_CONFIGURATION
          )
        ) {
          riskIndicatorConfigurationPermitted = true;
        }
      }
    });
    if (alertsListingPermitted) {
      homeUrl = '/app/crs/customers';
    } else if (riskIndicatorConfigurationPermitted) {
      homeUrl = '/app/crs/riskIndicatorConfiguration';
    } else if (globalSettingsPermitted) {
      homeUrl = '/app/crs/settings';
    }
  }

  const routes = (
    <Switch>
      {/* Set the route for the landing page */}
      {homeUrl ? (
        <Route exact path="/app" render={() => <Redirect to={homeUrl} />} />
      ) : null}

      <Route exact path="/app/crs" render={() => <Redirect to={homeUrl} />} />

      {alertsListingPermitted ? (
        <Route
          exact
          path="/app/crs/customers"
          render={() => {
            return RestrictedRender(CRSListingPage);
          }}
        />
      ) : null}

      {investigationPagePermitted ? (
        <Route
          exact
          path="/app/crs/details/:alertId"
          component={CRSDetailPage}
        />
      ) : null}

      {riskIndicatorConfigurationPermitted ? (
        <Route
          exact
          path="/app/crs/riskIndicatorConfiguration"
          render={() => {
            return RestrictedRender(CrsRiskIndicator);
          }}
        />
      ) : null}

      {globalSettingsPermitted ? (
        <Route
          exact
          // TODO: need to update to /app/settings
          path="/app/crs/settings"
          render={() => {
            return RestrictedRender(CRSSettings);
          }}
        />
      ) : null}
      <Route path="*" component={NotFoundPage} />
    </Switch>
  );
  return routes;
};
